import { styled } from 'styled-components';
import TableItem from '../../components/Table/TableItem';
import FirstTableItem from '../../components/Table/FirstTableItem';

export const Container = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  flex-direction: row;
  min-height: 100vh;
  background-color: #faf5f6;
  gap: 33px;
  padding-right: 33px;
  @media (max-width: 800px) {
    padding-top: 50px;
    padding-left: 33px;
  }
`;
export const ContentContainer = styled.div`
  padding-bottom: 100px;
  padding-left: 265px;
  width: 100%;
  @media (max-width: 800px) {
    padding-left: 0;
  }
`;
export const FirstItem = styled(FirstTableItem)`
  padding-left: 18px;
`;
export const LastTableItem = styled(TableItem)`
  padding-right: 16px;
  justify-content: flex-end;
  max-width: ${props => (props.$chevron ? '50px' : '250px')};
  min-width: ${props => (props.$chevron ? '50px' : '250px')};
  width: ${props => (props.$chevron ? '50px' : '250px')};

  cursor: pointer;
  &:active {
    opacity: 0.6;
  }
`;
export const StatusTableItem = styled.button`
  display: flex;
  width: 81px;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: ${props => (props.$completed ? 'rgba(0, 0, 0, 0.50)' : '#6c7e75')};
  border: none;
  outline: none;
  font-size: 12px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  letter-spacing: -0.408px;
  border-radius: 8px;
  background: ${props => (props.$completed ? 'rgba(0, 0, 0, 0.10)' : '#D8E2DD')};
`;

export const Title = styled.span`
  color: #000;
  font-family: Playfair Display;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px;
`;

export const EmptyTable = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  overflow: auto;
  /* min-height: 747px; */
  min-height: 875px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const TemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

export const TemplateTitle = styled.span`
  font-family: 'Poppins-SemiBold';

  font-size: 18px;
  letter-spacing: -0.408px;
`;

export const TemplateDescription = styled.span`
  font-family: 'Poppins-Regular';

  font-size: 15px;

  letter-spacing: -0.408px;
  opacity: 0.5;
`;

export const NoDataContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 15px;
`;

export const CheckboxContainer = styled.div`
  cursor: pointer;

  display: flex;
  width: 51px;

  height: 51px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const ModalTemplateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
export const StatusTableContainer = styled.td`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 250px;
  max-width: 250px;
`;

export const LoaderContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1;
  width: 100%;
`;

export const LoaderContainerMargin = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 15px;
`;

export const ErrorTitle = styled.span`
  color: #ff0000;
  font-family: 'Poppins-Regular';

  font-size: 18px;
  letter-spacing: -0.408px;
  align-self: center;
  margin-top: 10px;
`;

export const ClientModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 10px;
`;
